(function () {
  'use strict';

  var module = angular.module('uwAgenda.website.privacypolicy');

  module.factory('PrivacyPolicyService', ['$http', '$q', 'SharedAgendaService', 'AppConfig', '$translate', PrivacyPolicyServiceFn]);

  function PrivacyPolicyServiceFn($http, $q, SharedAgendaService, AppConfig, $translate) {
    
    const base = '/api/websites/privacy-policy';
    
    return {
      getUploadedPolicies: getUploadedPolicies,
      uploadPolicy: uploadPolicy,
      getDownloadPolicyUrl: getDownloadPolicyUrl,
      getDownloadDefaultPolicyUrlAsync: getDownloadDefaultPolicyUrlAsync,
      removePolicy: removePolicy
    };

    /**
     * Get all uploaded privacy policies for the current agenda
     */
    function getUploadedPolicies() {
      var agendaId = SharedAgendaService.data.currentAgenda.id;
      return $http.get(base + '/uploaded-policies/' + agendaId)
        .then(function (response) {
          return response.data;
        }, function (error) {
          return $q.reject(error);
        });
    }

    /**
     * Upload a privacy policy PDF for a specific language
     */
    function uploadPolicy(file, languageId) {
      var agendaId = SharedAgendaService.data.currentAgenda.id;
      var fd = new FormData();
      fd.append('file', file);
      fd.append('languageId', languageId);
      fd.append('agendaId', agendaId);

      return $http.post(base + '/upload', fd, {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      })
        .then(function (response) {
          return response.data;
        }, function (error) {
          return $q.reject(error);
        });
    }

    /**
     * Download a privacy policy PDF
     */
    function getDownloadPolicyUrl(id) {
      var agendaId = SharedAgendaService.data.currentAgenda.id;
      return AppConfig.ApiUrl + base + '/download/' + agendaId + '/' + id;
    }

    function getDownloadDefaultPolicyUrlAsync() {
      return $translate('default_policy_url').then(path => AppConfig.ApiUrl + path);
    }

    /**
     * Remove a privacy policy for a specific language
     */
    function removePolicy(languageId) {
      var agendaId = SharedAgendaService.data.currentAgenda.id;
      return $http.delete(base + '/remove/' + agendaId + '/' + languageId)
        .then(function (response) {
          return response.data;
        }, function (error) {
          return $q.reject(error);
        });
    }
  }
})();

